import MyWangEditor from './MyWangEditor'
export default MyWangEditor



// WEBPACK FOOTER //
// ./src/components/MyWangEditor/index.js